import { render, staticRenderFns } from "./EmailInstructions.vue?vue&type=template&id=ba4d0082"
import script from "./EmailInstructions.vue?vue&type=script&lang=js"
export * from "./EmailInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports